/**
 * ErrorList  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { FC } from "react";
import { BEM } from "@adapptio/lib-components";

export interface IItemListRowMessageProps {
	className?: string;
}

export const ItemListRowMessage: FC<IItemListRowMessageProps> = ({
	className,
	children
}) => {
	const baseClass = BEM("edt-item-list", "row-message");

	if (className) {
		baseClass.add(className);
	}

	return (
		<div className={baseClass.toClassName()}>
			{children}
		</div>
	);
};
